import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, catchError, concatMap, debounceTime, distinctUntilChanged, Observable, of, Subject, Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { CommonValues } from "src/app/services/commonValues";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { UtilService } from "src/app/services/util.service";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-members",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, UserCardComponent, CommonSkeletonComponent, NodataFoundComponent, FilterPipe, TruncatePipe, InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./members.component.html",
  styleUrls: ["./members.component.scss"],
})
export class MembersComponent implements OnInit , OnDestroy{
  @Input() communityData ;
  userData = [];
  values: any = {
    members: [],
  };
  communityList = new BehaviorSubject<any[]>([])
  communitypayload = {
    communityId: null,
    limit: 18,
    status:"ALL",
    searchAfterKey: null,
    searchContent: null
 }
 stopScroll : boolean = false;
 previouseAfterKey : any = null;
  communityId;
  communitySuperadmin;
  name: string = "";
  loadAPIcall:boolean=false
  inivateAcceptdata: any;
  AllData: boolean = true;
  selectedFilter: string = 'All';
  invitedMember: boolean = true;
  adminData: boolean = true;
  AdminFilterData: any;
  RevokeFilterData: any;
  revokeData: boolean = true;
  tempAdminFilterData: any;
  tempRevokeFilterData: any;
  tempInivateAcceptdata: any;
  memberCount: boolean = true;
  AdminCount: boolean = false;
  AdminFilterDatalength: any;
  admin: any;
  membersList: any;
  tempmembersList = [];
  userCardConfig: UserCardConfig[] = [];
  noDatafound: Array<string> = ["No Data to display"];
  noDatafoundadmin: Array<string> = ["You have no admin"];
  noDatafoundinvited: Array<string> = ["You have no invitations sent yet"];
  noDatafoundrevoke: Array<string> = ["No Data to display"];
  searchKeyData
  emitter: Subscription
  showNoDatafound: boolean = false;
  valueChanged: any;
  searchSubject = new Subject<string>();
  scrollSubject = new BehaviorSubject<string>(null);
  loadScroll: boolean;
  total: number = 0;
  constructor(
    private api: ApiService,
    private commonvalues: CommonValues,
    private router: Router,
    private route: ActivatedRoute,
    private util: UtilService,
  ) {
    this.commonvalues.getcommunitydata().subscribe((res) => {
      this.values = res;
    });

    this.emitter = this.commonvalues.getCommunityEventEmitter().subscribe(res => {
      this.valueChanged = res.boolean
      if (this.valueChanged == true) {
        this.members()
      }
    })
    this.route.queryParams.subscribe((res) => {
      this.communityId = res.communityId;
      this.communitypayload.communityId = this.communityId;
      this.values.menu = "memberspage";
     });
  }

  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
    this.scrollSubject.unsubscribe();
  }

  ngOnInit() {

    this.members();
    this.communitySuperadmin = localStorage.getItem("communitySuperadmin");
    this.admin = localStorage.getItem("isSuperAdmin");
    console.log("total count " , this.communityData);

    if (
      this.communitySuperadmin == "true" ||
      this.communitySuperadmin == true
    ) {
      this.communitySuperadmin = true;
      if (this.admin === "true") {
        let revokeBtn: UserCardConfig = new UserCardConfig(
          "Revoke",
          this.removedata,
          this.canShow,
          true
        );
        revokeBtn.source = this;
        this.userCardConfig.push(revokeBtn);
      }
    } else {
      this.communitySuperadmin = false;
    }
    // Searches run STRICTLY one at a time. This used to call members() straight
    // from the subscribe, which subscribes to community/members itself, so every
    // keystroke that survived the debounce fired its own request with no regard
    // for one already in flight. Overlapping calls came back out of order and the
    // list rendered whichever landed last, not the one matching what was typed.
    //
    // concatMap is deliberate, not switchMap: switchMap would cancel the earlier
    // request, and the ask here is that the first COMPLETES before the next is
    // processed, then the next, and so on.
    //
    // The payload is mutated inside the projection, not in a tap before it,
    // because concatMap only runs the projection when it is ready to subscribe -
    // building the payload earlier would let a later search overwrite
    // searchContent while an earlier request was still queued.
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      concatMap((res: string) => {
        this.loadScroll = false;
        this.resetPayload();
        this.communitypayload.searchContent = res;
        this.loadAPIcall = true;
        return this.fetchMembers().pipe(
          // Keep the queue alive: an error on one search must not tear down the
          // pipeline and leave the box dead for the rest of the session.
          catchError(() => of(null))
        );
      })
    ).subscribe(resMembers => {
      this.applyMembersResponse(resMembers);
    });

    this.scrollSubject.pipe(
        debounceTime(100),
        distinctUntilChanged()
    ).subscribe(res=>{
      if(res!=null){
        this.loadScroll =  true;
        this.communitypayload.searchAfterKey =  this.previouseAfterKey;
        this.members();
      }
    });

  }


  resetPayload(){
    this.communityList.next([]);
    this.communitypayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
  }

  canShow(data, source): boolean {
    return this.communitySuperadmin;
  }

  removedata(data) {
    data.userId;
    this.communityId;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure you want to remove?",
        text: "This member will be removed from this community page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          let datas: any = {};
          datas.communityId = this.communityId;
          datas.userId = data.userId;
          this.util.startLoader();
          this.api
            .create("community/remove/members", datas)
            .subscribe((res) => {
              this.util.stopLoader();
              if (res.code == "00000") {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Community member",
                  text: "Member has been removed",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                  const currentMembers = this.communityList.getValue();
                  const updatedMembers = currentMembers.filter(members => members.userId !== data.userId);
                  this.communityList.next(updatedMembers);
                  this.userData = updatedMembers;
                  this.total = Math.max(0, this.total - 1);

                  this.members();
                })
              }
            }, err => {
              this.util.stopLoader();

            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // Swal.fire({
          //   position: "center",
          //   icon: "success",
          //   title: "Community member",
          //   text: "Member is safe",
          //   showConfirmButton: false,
          //   timer: 1500,
          // });
        }
      });
  }
  acceptUser(user) {
   let requestData = {
    communityId: this.communityId,
    userId: user.userId,
    status: "REVOKED"
  };
    this.util.startLoader();
    this.api.create("community/request/accept", requestData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "User Accepted",
          text: "User accepted successfully.",
          timer: 2000,
          showConfirmButton: false
        })
        this.resetPayload();
        this.members();
        this.refreshBannerMemberCount();
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  /**
   * Accept only. Refreshes the banner's "N Members" pill straight after a revoked user is
   * accepted back.
   *
   * REVOKE does not need this: it happens on the All list, so the members() refresh that
   * follows already carries the new all-members `total` into localStorage, which the banner
   * picks up. ACCEPT happens on the REVOKED filter - resetPayload() leaves
   * communitypayload.status as 'REVOKED', so members() reloads the revoked list and the
   * full member total is never fetched. Without this call the pill stays on the old number.
   *
   * noOfMembers is counted live from the membership rows (CommunityService.communityHome),
   * so it does not inherit the drift in the stored memberCnt. Writing the key is enough -
   * community-banner polls it every 500ms and emits the change to the component that
   * renders the pill.
   */
  private refreshBannerMemberCount(): void {
    if (!this.communityId) { return; }
    const payload: any = {
      communityId: this.communityId,
      userId: localStorage.getItem('userId'),
    };
    this.api.create('community/home', payload).subscribe(
      (res: any) => {
        const count = res?.data?.noOfMembers;
        if (res?.code === '00000' && count != null) {
          localStorage.setItem('communitycount', String(count));
        }
      },
      () => {
        // Leave the pill on its current number rather than blanking it.
      }
    );
  }

  /*
   * No extra community/home call here on purpose.
   *
   * The banner's "N Members" line is fed by localStorage['communitycount'], which it polls
   * every 500ms (community-banner ngAfterViewInit). Two things already keep that key correct
   * after a revoke or an accept, so a dedicated request would only add traffic:
   *
   *   1. members() runs immediately after either action, and applyMembersResponse writes the
   *      live `this.total` (the listing's hits.totalHits) into that key.
   *   2. community-banner's companyHome() now reads noOfMembers from its own click-triggered
   *      membership check and writes the same key.
   *
   * The banner used to be stale because it wrote community/details' memberCnt - a stored
   * counter that drifts - back over the live value. That write is gone.
   */


  userprofile(data) {
    var userData: any = {};
    userData.userId = data;

    this.router.navigate(["personalProfile"], { queryParams: userData });

  }

  sendmsg(data) {
    var userData: any = {};
    userData.userid = data.userId;
    this.router.navigate(["message"], { queryParams: userData });
  }

  connect(data) {
    data.requestedBy = localStorage.getItem("userId");
    this.util.startLoader();
    this.api.create("user/connect", data).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        this.members();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: "Connection request",
          text: "Request sent successfully",
          //showConfirmButton: true,
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 1500
        })
      } else if (res.code == "88888") {
      }
    }, err => {
      this.util.stopLoader();

    });
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  keyupdata(event) {
    if (event.target.value.length == 0) {
      this.onsearch('');
    }
  }

  onsearch(val) {
    console.log("onsearch called with value:", val);
    if (val != undefined) {
      val = val.trim().toLowerCase();
    }


    if (this.AllData) {
      this.membersList = this.tempmembersList;
      this.membersList = this.filterByString(this.membersList, val);
      if (this.membersList.length == 0) {
        this.showNoDatafound = true;
        this.noDatafound = ["No Data to display"];
      } else {
        this.showNoDatafound = false;
      }
    }
    else if (this.adminData) {
      this.AdminFilterData = this.tempAdminFilterData;
      this.AdminFilterData = this.filterByString(this.AdminFilterData, val);
      if (this.AdminFilterData.length == 0) {
        this.showNoDatafound = true;
        this.noDatafoundadmin = ["No data to display"];
      } else {
        this.showNoDatafound = false;
      }
    }
    // else if(this.revokeData){
    //   this.RevokeFilterData = this.tempRevokeFilterData;
    //   this.RevokeFilterData = this.filterByString(this.RevokeFilterData, val);
    //   if (this.RevokeFilterData.length == 0) {
    //     this.showNoDatafound = true;
    //     this.noDatafoundrevoke = ["No data to display"];
    //   } else {
    //     this.showNoDatafound = false;
    //   }
    // }

    else if (this.invitedMember) {
      this.inivateAcceptdata = this.tempInivateAcceptdata;
      this.inivateAcceptdata = this.filterByString(this.inivateAcceptdata, val);
      if (this.inivateAcceptdata.length == 0) {
        this.showNoDatafound = true;
        this.noDatafoundinvited = ["No data to display"];
      } else {
        this.showNoDatafound = false;
      }
    }
  }

  filterByString(data, s) {
    return data.filter(e => e.userName.toLowerCase().includes(s))
      .sort((a, b) => a.userName.toLowerCase().includes(s) && !b.userName.toLowerCase().includes(s) ? -1 : b.userName.toLowerCase().includes(s) && !a.userName.toLowerCase().includes(s) ? 1 : 0);
  }
  setFilter(filterName: string) {
    this.selectedFilter = filterName;
    this.resetPayload(); // Reset previous data
    this.communitypayload.status = filterName;
    this.AdminFilterData = [];
    this.RevokeFilterData = [];
    this.userCardConfig = [];
    if (filterName === 'REVOKED') {
      let acceptBtn: UserCardConfig = new UserCardConfig(
        "Accept",
        this.acceptUser,
        this.canShow,
        true
      );
      acceptBtn.source = this;
      this.userCardConfig.push(acceptBtn);
   }else  if (filterName === 'All'|| filterName === 'ADMIN') {
    let revokeBtn: UserCardConfig = new UserCardConfig(
      "Revoke",
      this.removedata,
      this.canShow,
      true
    );
    revokeBtn.source = this;
    this.userCardConfig.push(revokeBtn);
  }

    this.members();
 }
  /**
   * The community/members request on its own, so callers can decide how to
   * sequence it. The search pipeline feeds this through concatMap to run one at
   * a time; everything else still goes through members() below and fires
   * immediately, which is what those call sites want.
   */
  private fetchMembers(): Observable<any> {
    this.userData = [];
    return this.api.create("community/members", this.communitypayload);
  }

  members() {
   this.loadAPIcall=true;
    this.fetchMembers()
      .subscribe((resMembers) => {
        this.applyMembersResponse(resMembers);
      }, err => {
        this.loadAPIcall = false;
        this.util.stopLoader();
      });
  }

  /**
   * Everything that happens to the list once a response lands. Shared by the
   * serialised search pipeline and by members(), so both render identically -
   * previously this logic only existed inside members()'s own subscribe and any
   * other caller would have had to duplicate it.
   *
   * A null response means the request failed and was swallowed to keep the
   * search queue alive; the list is left exactly as it was.
   */
  private applyMembersResponse(resMembers: any) {

        this.loadAPIcall=false;
        this.loadScroll = false;

        if(resMembers && resMembers.code === GigsumoConstants.SUCESSCODE){

          const data = resMembers.data.communityMembersList;
          const searchAfteKey = resMembers.data.searchAfterKey;

          if((data && data.length === 0) || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfteKey)){
            this.stopScroll = true;
          }

          if (resMembers.data.total != null) {
            this.total = resMembers.data.total;
          }

          if(data){
            const exist = this.communityList.getValue();
            const current = data;

            const combined =  [...exist , ...current];
            if(combined){
              combined.forEach((element) => {
                if (
                  element.userId != "undefined" ||
                  element.userId != "null" ||
                  element.userId != ""
                ) {
                  element.page = 'COMMUNITY'
                  element.menu = "memberspage"
                  element.userName = element.firstName + " " + element.lastName;
                }
              });
            }

            this.communityList.next(combined);
          }

          // Only the UNFILTERED, UNSEARCHED member list may feed the banner's count.
          //
          // community-banner polls this key every 500ms (ngAfterViewInit) and renders it as the
          // "N Members" line. `data` is only the CURRENT PAGE, so its length is wrong - but so
          // is a filtered `total`: this same component also serves the ADMIN / REVOKED /
          // INVITED filters and the member search, where `total` counts THAT subset. Writing it
          // unconditionally put the admin count into the banner ("7 Members" beside a
          // 707-member list).
          const isFullMemberList =
            String(this.communitypayload.status || '').toUpperCase() === 'ALL'
            && !this.communitypayload.searchContent;
          if (isFullMemberList && this.total != null) {
            localStorage.setItem('communitycount', String(this.total));
          }
          this.previouseAfterKey = searchAfteKey;

          this.util.stopLoader();
          if (resMembers.data.communityMembersList != null) {
            this.adminData = false;
            this.AllData = true;
            this.revokeData = false;
            this.invitedMember = false;
            this.memberCount = true;
            this.AdminCount = false;

          }

        }
  }

  sortData(data) {
    return data.sort((a, b) => {
      return <any>new Date(b.memberOn) - <any>new Date(a.memberOn);
    });
  }

  datas(datas) {
    this.values.menu = "memberspage";
    this.userData = datas;
    this.values.members = this.userData;
    this.commonvalues.communitydata(this.values);
  }


  onSearchCommunity(v : string){
    this.searchSubject.next(v)
  }

  onScrollDown(){
    if(!this.stopScroll){
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }

}

